import { render } from "./HeroiconsOutlineTicket.vue?vue&type=template&id=2aa816fd"
const script = {}

import exportComponent from "/www/yadonor/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineTicket.vue"]])

export default __exports__